import { render, staticRenderFns } from "./verified_article.vue?vue&type=template&id=6069b29e&scoped=true&lang=pug"
import script from "./verified_article.vue?vue&type=script&lang=js"
export * from "./verified_article.vue?vue&type=script&lang=js"
import style0 from "./verified_article.vue.css?vue&type=style&index=0&id=6069b29e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6069b29e",
  null
  
)

export default component.exports